'use client'

import { DatePicker } from '@components/primitives/DatePicker'
import { Text } from '@components/primitives/Text'
import { useState } from 'react'
import { trackQuestionModified } from './trackQuestionModified'
import type { DemographicsCollectElementProps } from './types'

export default function CollectDateOfBirth({
  formRef,
  patientProfileData: { dateOfBirth },
  trialApplyIdToken,
}: DemographicsCollectElementProps) {
  const [currentDateOfBirth, setCurrentDateOfBirth] = useState(dateOfBirth[0])

  const handleInputChange = (newInputValue: string) => {
    trackQuestionModified(newInputValue)([newInputValue])
    setCurrentDateOfBirth(newInputValue)
    setTimeout(() => formRef?.current?.dispatchEvent(new Event('input')))
  }

  return (
    <div className='flex w-full flex-col gap-2'>
      <Text
        className='text-neutral900'
        element={'p'}
        styleName='h3'
        value='When were you born?'
      />
      <Text
        className='text-neutral900'
        element={'p'}
        styleName='p-small'
        value='Select your birthdate'
      />
      <DatePicker
        id={trialApplyIdToken}
        initialValue={dateOfBirth[0] ?? ''}
        onChange={handleInputChange}
        required={true}
      />
      <input name='dateOfBirth' type='hidden' value={currentDateOfBirth} />
    </div>
  )
}
